import { useTranslation } from 'react-i18next';

/* ==========================================================================
   Omniversail demo i18n 适配层。
   内部复用生产站 i18next；所有 key 统一加 `ov.` 前缀
   （字典已并入 src/i18n/locales/<lng>.json 的顶层 `ov` 键），
   与站点既有翻译 key 完全隔离，互不影响、零冲突。
   组件体里的 t('hero.title1') 等调用无需改动。
   ========================================================================== */

/**
 * 归一化 i18n key：统一映射到 `ov.` 命名空间下。
 *
 * 幂等 —— 若调用方传入的 key 已经带有 ov 前缀则原样返回。
 * 这是防重复前缀回归的关键：历史上曾把 key 存成已带 ov 前缀的形式，
 * 再由本层无脑拼接一次，最终解析成两段 ov 的重复前缀，
 * 字典里查不到，i18next 会把整串 key 原样渲染到页面上
 * （表现为满屏 ov 开头的乱码文案）。
 *
 * 非字符串入参（例如尚未迁移的内联双语对象）会解析成空串，
 * 同样保持"可见"而不是静默吞掉，便于测试发现漏迁移的数据。
 */
export function ovKey(key) {
  const k = typeof key === 'string' ? key : '';
  return k.startsWith('ov.') ? k : `ov.${k}`;
}

export function useI18n() {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language || 'en').startsWith('zh') ? 'zh' : 'en';
  return {
    locale,
    i18n,
    t: (key, opts) => t(ovKey(key), opts),
  };
}

export default useI18n;
